import type { InternalAxiosRequestConfig } from 'axios';

let authToken: string | null = null;

export function setAuthToken(token: string): void {
  authToken = token;
}

export function getAuthToken(): string | null {
  return authToken;
}

export function requestInterceptor(
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }

  // CRITICAL: When sending FormData (multipart uploads), remove the default
  // 'Content-Type: application/json' header so the browser/Axios auto-sets
  // 'multipart/form-data' with the correct boundary string.
  // This is essential for Android WebView where the per-request
  // { 'Content-Type': undefined } override is unreliable.
  if (config.data instanceof FormData) {
    config.headers.delete('Content-Type');
    console.log('[RequestInterceptor] 📤 FormData detected, Content-Type header removed');
  }

  return config;
}
